module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "product-slide-card"
  }, [_c('v-flex', {
    staticClass: "product-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [(false) ? _c('v-flex', {
    staticClass: "product-user",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('profile-item', {
    attrs: {
      "user": _vm.publisher,
      "className": 'product-user-avatar'
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/' + _vm.publisher.slug
    }
  }, [_c('p', {
    staticClass: "product-user-name"
  }, [_vm._v(_vm._s(_vm.publisher.username))])]), _vm._v(" "), _c('div', {
    staticClass: "product-posted-at"
  }, [_c('img', {
    staticClass: "product-status-icon",
    attrs: {
      "src": "/static/images/ic_repeat.png"
    }
  }), _c('label', [_vm._v("reposted 10min ago")])])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "product-cover",
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "product-price"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.item.price)))]), _vm._v(" "), _c('div', {
    staticClass: "product-image",
    style: ({
      'background-image': 'url(' + _vm.item.covers[0].cover.url + ')'
    })
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "product-actions",
    attrs: {
      "xs12": "",
      "relative": ""
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    }
  }), _vm._v(" "), (_vm.showButtonAction) ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showButtonAction(_vm.item)
      }
    }
  }, [_vm._v("View Detail")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5838b4d1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/productslidecard.vue
// module id = 1732
// module chunks = 180